(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["cookie-notice"] && !Shopify.designMode) return;
  try {
    class CookieNotice extends HTMLElement {
    connectedCallback() {
      this.storageKey = 'pp-cookie-notice-dismissed';

      if (window.localStorage.getItem(this.storageKey) !== 'true') {
        this.removeAttribute('hidden');
      }

      const acceptButton = this.querySelector('.cookie-notice__accept');
      if (acceptButton) {
        acceptButton.addEventListener('click', this.dismiss.bind(this));
      }
    }

    dismiss() {
      window.localStorage.setItem(this.storageKey, 'true');
      this.setAttribute('hidden', '');
    }
  }

  customElements.define('cookie-notice', CookieNotice);
  } catch(e) { console.error(e); }
})();

})();
